// extracted by mini-css-extract-plugin
export default {"cls1":"NewUserDiscountButton-cls1_OQP","cls2":"NewUserDiscountButton-cls2__66 NewUserDiscountButton-cls1_OQP"};